import { deleteCookie, getCookie, setCookie } from 'cookies-next';

// QA Tests/Product Requirements
// 1. When users log out and back in, they should be redirected to the page they were on before logging out.
// 2. When users are auto-logged out via timeouts, they should be redirected to the page they were on before logging out.
// 3. When get server session goes wrong, the user should be redirected to the login page.
// 4. When users deny the EULA after direct navigating, they should be redirected to the page they were on before logging out.

export function sanitize(value) {
  return value.split('?')[0].split('#')[0];
}

export function setCallback(value) {
  value = sanitize(value);

  // Prevent accidentally setting the callback URL to a page that doesn't require authentication.
  const callbackBlacklist = [
    '/login',
    '/register',
    '/forgot-password',
    '/reset-password',
    '/terms-of-service',
    '/privacy-policy',
    '/sso',
  ];
  if (callbackBlacklist.includes(value)) {
    return;
  }
  setCookie('callbackUrl', JSON.stringify(value), { sameSite: 'strict' });
}

export function getCallback() {
  let callback = getCookie('callbackUrl');

  if (callback) {
    callback = JSON.parse(callback);
    return sanitize(callback);
  }
  return null;
}

export function deleteCallback() {
  deleteCookie('callbackUrl');
}
